export default __webpack_public_path__ + "static/media/BG_mobile_black.51e9601c.webp";